module.exports = __webpack_public_path__ + "img/shipping-mode.c415bb8e.svg";